import { render, staticRenderFns } from "./AiReportingChatModal.vue?vue&type=template&id=a4de084a&scoped=true&"
import script from "./AiReportingChatModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./AiReportingChatModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AiReportingChatModal.vue?vue&type=style&index=0&id=a4de084a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4de084a",
  null
  
)

export default component.exports